var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"enctype":"multipart/form-data"}},[_c('input',{ref:"file",staticClass:"file-upload",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.filesChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }